import Link from 'next/link';
import { useWindowSize } from 'react-use';

// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

// Components
import Icon from '@/components/base/Icon';
import Iconosquare from '@/components/icons/Iconosquare';
import { SideBar } from '@/components/layouts/LayoutPlatform/components/Menu/MenuMobile/Sidebar';

export function MenuMobile() {
    const { isOpen, toggle } = useToggle();
    const { width } = useWindowSize();

    if (isOpen && width > 639) {
        toggle();
    }

    return (
        <div className="mr-5 flex items-center gap-5 sm:hidden">
            <button
                onClick={toggle}
                data-testid="button-toggle-menu-mobile"
                className="flex items-center text-icoGray-500 dark:text-icoDarkMode-wolf">
                <Icon icon="menu-burger" />
            </button>
            <Link href="/" className="inline-block leading-none">
                <Iconosquare size={24} className="text-icoBlue" />
            </Link>
            <SideBar isMenuOpen={isOpen} toggleMenu={toggle} />
        </div>
    );
}
